export const LOAD_ASSETS = "LOAD_ASSETS";
export const LOAD_ASSETS_PROGRESS = "LOAD_ASSETS_PROGRESS";
export const LOAD_ASSETS_LOADED = "LOAD_ASSETS_LOADED";
export const LOAD_WEBSITE = "LOAD_WEBSITE";
